"use client";

import { useQuery } from "@tanstack/react-query";
import log from "logbeacon";
import { QUERY_KEYS } from "@config";
import { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";

interface PairsDetailRequest {
  /** 交易所名称 */
  exchange: string;
  /** 时间周期类型 */
  type: "short" | "medium" | "long";
  /** 交易对列表，支持多个交易对批量查询 */
  pairs: string[];
}

interface UsePairsDetailOptions {
  /** 查询参数 */
  params: PairsDetailRequest;
  /** 是否启用查询 */
  enabled?: boolean;
  /** 缓存时间（毫秒） */
  staleTime?: number;
}

/**
 * 获取交易对技术分析详情
 *
 * @param options 查询选项
 * @returns 查询结果和状态
 */
export const usePairsDetail = (options: UsePairsDetailOptions) => {
  const { chatApi } = useOspApiClientProvider();
  const { params, enabled = true, staleTime } = options;

  const { data, isLoading, isPending, isFetching, error, refetch } = useQuery({
    queryKey: [QUERY_KEYS.PAIRS_DETAIL, params],
    enabled: !!chatApi && enabled,
    staleTime,
    queryFn: async () => {
      log.debug("[文案]usePairsDetail queryFn params:", params);

      const { exchange, type, pairs } = params;
      // 使用 chatApi 查询交易对技术分析详情
      const res = await chatApi?.pairs.pairsDetail(
        exchange.toLowerCase(),
        type,
        { pairs },
      );

      if (res?.error) {
        log.error("[文案]usePairsDetail API error:", res.error);
        return Promise.reject(res.error);
      }

      log.debug("[文案]usePairsDetail API response:", res?.data);
      return res?.data?.data as any;
    },
  });

  return {
    data,
    isLoading,
    isPending,
    isFetching,
    error,
    refetch,
  };
};
